<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>{{ 'Total amount' | translate }}: {{ dataPayload.totalAmount | currency: basicInfo?.currencyCode
      }}</ion-title> <ion-buttons slot="end">
      <ion-button (click)="closeModal(null)" fill="clear">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<div class="inner-content">
  <div class="bg-light chip-row">
    <span class="chip" (click)="openCustomDiscountModal()">{{ '+ Add Discount' | translate }}</span>
    <span class="chip" (click)="removeCents()">{{ 'Remove Cents' | translate }}</span>
  </div>

  <div class="note  p-1">
    <ion-note color="warning">{{ 'Ensure all discounts or adjustments are applied before entering the amount given by
      the customer. Once the amount is entered, the change will be automatically calculated.' | translate }}</ion-note>
  </div>

  <ng-container *ngIf="!orderByLoyaltyPoints">
    <form [formGroup]="amountForm" class="pt-3">
      <ion-item class="bg-light">
        <ion-label position="floating">{{ 'Amount' | translate }}</ion-label>
        <ion-input formControlName="amount" (input)="calculateChanges()" numOnly min="0"></ion-input>
      </ion-item>
      <ion-label class="pt-2" *ngIf="amountForm.controls['amount'].errors && amountForm.controls['amount'].dirty"
        color="danger">{{ 'Enter Amount Should not be less than the total order amount.' | translate }}</ion-label>
    </form>

    <ion-text class="ion-text-center">
      <h2>{{ 'Changes' | translate }}: <ion-text color="danger">{{ remainingChanges | currency: basicInfo?.currencyCode
          }}</ion-text></h2>
    </ion-text>
  </ng-container>

  <div class="loader-wrapper" *ngIf="orderByLoyaltyPoints">
    <ion-icon class="spinner" name="cog-outline"></ion-icon>
    <h2>
      <small>{{ 'Order is processing by loyalty points...' | translate }}</small>
    </h2>
    <div class="syncing-info">
      <p class="note">{{ 'Please do not close the app while processing.' | translate }}</p>
    </div>

    <div class="progressbar">
      <span class="txt">{{ 'processing...' | translate }}</span>
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    </div>
  </div>
</div>

<ion-footer class="px-3 py-2" *ngIf="!orderByLoyaltyPoints">
  <ion-button fill="solid" type="submit" expand="block" color="primary" [disabled]="amountForm.invalid || loading"
    (click)="payByCash()">
    <span *ngIf="!loading">{{ 'Pay by cash' | translate }}</span>
    <ion-spinner name="dots" *ngIf="loading"></ion-spinner>
  </ion-button>
</ion-footer>